import axios from 'axios';

export default function ExportLeadsButton() {
  const downloadCSV = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.warn('No token found. Please log in.');
        return;
      }

      const response = await axios.get('/api/leads/export', {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'leads.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('❌ Error downloading leads CSV:', error);
    }
  };

  return (
    <div style={{ textAlign: 'center', margin: '20px 0' }}>
      <button
        onClick={downloadCSV}
        style={{
          padding: '10px 20px',
          backgroundColor: '#28a745',
          color: 'white',
          fontWeight: 'bold',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        📥 Export Leads to CSV
      </button>
    </div>
  );
}
